var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-badge',{staticClass:"app-badge",attrs:{"variant":"warning"}},[_vm._v(_vm._s(_vm.translate('BETA')))])
}
var staticRenderFns = []

export { render, staticRenderFns }